<template>

  <div class="container">
    <h3 class="main-title">Profesión</h3>
    <form @submit.prevent="submit" novalidate>
      <fieldset>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="category">Actividad económica:</label>
            <span class="select">
              <select v-model.trim="$v.category.$model" :class="{ 'error-label': $v.category.$error }" @change="getActivities()">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="cat in categories" :key="cat.pk" :value="cat.pk">
                  {{ cat.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.category.required">La actividad económica es obligatoria</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="activity" :class="{'error-text': endpointErrors.activity}">Actividad específica:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.activity.$model" :class="{ 'error-label': $v.userInteraction.activity.$error || endpointErrors.activity }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="act in activities" :key="act.pk" :value="act.pk">
                  {{ act.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.activity.required">La actividad específica es obligatoria</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="exportProducts" :class="{'error-text': endpointErrors.export_products}">¿Exportas productos desde México?</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.exportProducts.$model" :class="{ 'error-label': $v.userInteraction.exportProducts.$error || endpointErrors.export_products }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="bool in selectBooleanValues" :key="bool.value" :value="bool.value">
                  {{ bool.general }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.exportProducts.required">Esta pregunta es obligatoria</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="importProducts" :class="{'error-text': endpointErrors.import_products}">¿Importas productos a México?</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.importProducts.$model" :class="{ 'error-label': $v.userInteraction.importProducts.$error || endpointErrors.import_products }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="bool in selectBooleanValues" :key="bool.value" :value="bool.value">
                  {{ bool.general }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
             <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.importProducts.required">Esta pregunta es obligatoria</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="useMetalCoins" :class="{'error-text': endpointErrors.use_metal_coins}">¿Utilizas metales amonedados?</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.useMetalCoins.$model" :class="{ 'error-label': $v.userInteraction.useMetalCoins.$error || endpointErrors.use_metal_coins }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="bool in selectBooleanValues" :key="bool.value" :value="bool.value">
                  {{ bool.general }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.useMetalCoins.required">Esta pregunta es obligatoria</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="foreignRelations" :class="{'error-text': endpointErrors.foreign_relations}">¿Mantienes relación con otros países?</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.foreignRelations.$model" :class="{ 'error-label': $v.userInteraction.foreignRelations.$error || endpointErrors.foreign_relations }" @change="handleCountries()">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="bool in selectBooleanValues" :key="bool.value" :value="bool.value">
                  {{ bool.general }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.foreignRelations.required">Esta pregunta es obligatoria</span>
            </p>
          </div>
        </div>
        <transition name="fade">
          <div class="row row-responsive" v-if="this.userInteraction.foreignRelations">
            <div class="row row-responsive">
              <div class="column column-xs-100 column-sm-50 column-offset-sm-50">
                <label for="selectedCountries" :class="{'error-text': endpointErrors.countries}">Seleccione los países:</label>
                <multiselect v-model.trim="$v.userInteraction.selectedCountries.$model" placeholder="Seleccione uno o más países" label="name" track-by="pk" :options="countries" :multiple="true" :taggable="true"></multiselect>
                <p class="error" v-if="errors">
                  <span v-if="!$v.userInteraction.selectedCountries.requiredIf">Debe seleccionar países</span>
                </p>
              </div>
            </div>
          </div>
        </transition>
        <div class="row">
          <div class="column">
            <button class="button float-right" @click.prevent="submit()">Siguiente</button>
          </div>
        </div>
        <div class="row">
          <div class="column box-errors">
            <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
            </p>
            <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
            </p>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

</template>

<script>

import Multiselect from 'vue-multiselect'
import { required, requiredIf } from 'vuelidate/lib/validators'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'StepProfession',
  components: {
    Multiselect
  },
  data () {
    return {
      endpointErrors: {
        activity: false,
        foreign_relations: false,
        use_metal_coins: false,
        export_products: false,
        import_products: false,
        countries: false
      },
      errors: false,
      empty: false,
      countries: [],
      activities: [],
      categories: [],
      category: '',
      tmpCountries: [],
      selectBooleanValues: [
        {
          general: 'Si',
          value: true
        },
        {
          general: 'No',
          value: false
        }
      ],
      userInteraction: {
        importProducts: '',
        exportProducts: '',
        useMetalCoins: '',
        foreignRelations: '',
        activity: '',
        selectedCountries: []
      }
    }
  },
  validations: {
    category: { required },
    userInteraction: {
      activity: { required },
      importProducts: { required },
      exportProducts: { required },
      useMetalCoins: { required },
      foreignRelations: { required },
      selectedCountries: {
        requiredIf: requiredIf((obj) => {
          return obj.foreignRelations === true
        })
      }
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  methods: {
    sendDataToServer: async function (allCountries) {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/professions/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          import_products: this.userInteraction.importProducts,
          export_products: this.userInteraction.exportProducts,
          use_metal_coins: this.userInteraction.useMetalCoins,
          foreign_relations: this.userInteraction.foreignRelations,
          activity: this.userInteraction.activity,
          countries: allCountries
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.nextStep()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.activity = ('activity' in
              response.data)
            this.endpointErrors.foreign_relations = ('foreign_relations' in
              response.data)
            this.endpointErrors.use_metal_coins = ('use_metal_coins' in
              response.data)
            this.endpointErrors.export_products = ('export_products' in
              response.data)
            this.endpointErrors.import_products = ('import_products' in
              response.data)
            this.endpointErrors.countries = ('countries' in
              response.data)
            break
          default:
            break
        }
      }
    },
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        let countriesIds = this.userInteraction.selectedCountries.map(
          ({ pk }) => pk)
        this.sendDataToServer(countriesIds)
      }
    },
    handleCountries: function () {
      if (this.userInteraction.foreignRelations === false) {
        this.userInteraction.selectedCountries = []
      }
    },
    getCategories: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/categories/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.categories = response.data
      }
    },
    getActivities: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/activities/',
        params: {
          category: this.category
        },
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.activities = response.data
      }
    },
    getCountries: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/countries/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.countries = response.data
      }
    }
  },
  created: function () {
    this.getCategories()
    this.getCountries()
  }
}
</script>

<style lang="scss">

.multiselect__element {
  margin-bottom: 0;

  &:before {
    display: none;
  }

  .multiselect__option {
    padding: 6px;
    min-height: 28px;
    line-height: 14px;
    font-size: 12px;
  }
}

input[type='text'].multiselect__input {
  height: 2.5rem;
}

.multiselect ~ .error {
  margin-top: .7rem;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepProfession.vue